(() => {
  'use strict';
  const init = (scope = document) => {
    scope.querySelectorAll('[data-s2t-size-product]').forEach(root => {
      if (root.dataset.sizeReady) return;
      root.dataset.sizeReady = 'true';
      const form = root.querySelector('[data-s2t-size-form]');
      const total = root.querySelector('[data-size-total]');
      const add = root.querySelector('[data-size-add]');
      const error = root.querySelector('[data-size-error]');
      const prompt = root.querySelector('[data-size-price-prompt]');
      const priced = root.querySelector('[data-size-priced]');
      const status = root.querySelector('[data-size-app-status]');
      let queued = false;
      const amount = () => Number(total.textContent.replace(/[^0-9.]/g, ''));
      const complete = () => {
        const file = form.querySelector('[name="properties[upload]"]');
        return Boolean(file && file.value && amount() > 0);
      };
      const update = () => {
        queued = false;
        const mounted = !!form.querySelector('.cl-po--option');
        if (status.hidden !== mounted) status.hidden = mounted;
        const hasPrice = amount() > 0;
        root.dataset.sizeHasPrice = String(hasPrice);
        const quantity = form.querySelector('[name="quantity"]');
        if (quantity && !quantity.getAttribute("aria-label")) { quantity.setAttribute("aria-label", "Transfer quantity"); quantity.setAttribute("inputmode", "numeric"); }
        form.querySelectorAll(".cl-po--quantity-btn").forEach(control => {
          if (control.getAttribute("role")) return;
          control.setAttribute("role", "button"); control.setAttribute("tabindex", "0");
          const inputName = control.parentElement.querySelector('input')?.name || '';
          const field = inputName.includes('_dimension_x') ? 'width' : inputName.includes('_dimension_y') ? 'height' : 'transfer quantity';
          control.setAttribute("aria-label", `${control.textContent.trim() === "+" ? "Increase" : "Decrease"} ${field}`);
          control.addEventListener("keydown", event => {if (["Enter", " "].includes(event.key)) {event.preventDefault();control.click();}});
        });
        if (priced.hidden === hasPrice) priced.hidden = !hasPrice;
        if (prompt.hidden !== hasPrice) prompt.hidden = hasPrice;
        const ready = complete() && form.dataset.submitting !== 'true';
        if (add.disabled === ready) add.disabled = !ready;
        // Correct the app's existing heading only within this product section.
        form.querySelectorAll('.cl-po--label').forEach(label => {
          if (label.textContent.trim() === 'By More & Save More') label.textContent = 'Buy more & save more';
        });
      };
      const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
      const observer = new MutationObserver(schedule);
      observer.observe(form, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['value','data-filepond-item-state']});
      form.addEventListener('input', schedule);
      form.addEventListener('change', schedule);
      // Keep the app fields intact. This guard prevents an
      // unconfigured zero-price order; it never fabricates option properties.
      form.addEventListener('submit', event => {
        if (!complete()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          error.textContent = 'Finish uploading your artwork and check your dimensions and quantity before adding to cart.';
          error.hidden = false;
          return;
        }
        error.hidden = true;
      }, true);
      update();
      const timer = setTimeout(() => {
        if (!form.querySelector('.cl-po--option')) status.textContent = 'Your custom options could not load. Please refresh the page or contact the S2T team for help.';
      }, 18000);
      root.addEventListener('click', event => {
        const thumb = event.target.closest('[data-size-image]');
        if (!thumb) return;
        const image = root.querySelector('.s2t-size__image');
        image.removeAttribute('srcset');
        image.src = thumb.dataset.sizeImage;
        image.alt = thumb.dataset.sizeAlt;
        root.querySelectorAll('[data-size-image]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
      });
      root._sizeCleanup = () => { observer.disconnect(); clearTimeout(timer); };
    });
    scope.querySelectorAll('[data-size-recommendations]').forEach(root => {
      if (root.dataset.sizeReady) return;
      root.dataset.sizeReady = 'true';
      const rail = root.querySelector('[data-size-rail]');
      const prev = root.querySelector('[data-size-prev]');
      const next = root.querySelector('[data-size-next]');
      const boundaries = () => { prev.disabled = rail.scrollLeft <= 2; next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 3; };
      const move = sign => rail.scrollBy({left:sign * (rail.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      prev.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
      rail.addEventListener('scroll', boundaries, {passive:true});
      rail.addEventListener('keydown', event => { if (event.target !== rail) return; if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();move(event.key === 'ArrowRight'?1:-1);} });
      const resize = new ResizeObserver(boundaries); resize.observe(rail); boundaries();
      const controller = new AbortController();
      // Shopify sorts this collection response by actual sales; the fallback
      // stays usable in collection order without an unsupported best-seller label.
      const url = new URL(root.dataset.sizeCollection, location.origin);
      url.searchParams.set('sort_by','best-selling'); url.searchParams.set('view','s2t-size-recommendations');
      fetch(url, {signal:controller.signal,credentials:'same-origin'}).then(r => {if(!r.ok)throw new Error('Collection unavailable');return r.text();}).then(html => {
        const result = new DOMParser().parseFromString(html,'text/html').querySelector('[data-size-sorted-products][data-sort="best-selling"]');
        if (!result || !result.children.length) return;
        rail.replaceChildren(...result.children);
        root.querySelector('[data-size-recommendation-title]').textContent = root.dataset.sizeBestHeading;
        boundaries();
      }).catch(() => {/* Keep server-rendered products and honest fallback title. */});
      root._sizeCleanup = () => {controller.abort();resize.disconnect();};
    });
  };
  // App listeners on the form run first; use the resulting complete FormData.
  // This mirrors the existing Leatherette drawer integration without copying
  // its minimum quantity or pricing logic.
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-s2t-size-form]');
    if (!form || event.defaultPrevented) return;
    event.preventDefault();
    const button = form.querySelector('[data-size-add]');
    const error = form.querySelector('[data-size-error]');
    if (form.dataset.submitting === 'true') return;
    form.dataset.submitting = 'true';
    button.disabled = true;
    button.textContent = 'Adding…';
    error.hidden = true;
    try {
      const response = await fetch('/cart/add.js', {method:'POST',body:new FormData(form),credentials:'same-origin',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Your transfer could not be added. Please try again.');
      if (typeof window.upcartRefreshCart === 'function') await window.upcartRefreshCart();
      if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
      else { window.location.assign('/cart'); return; }
      button.textContent = 'Added to cart';
    } catch (err) {
      error.textContent = err.message || 'Your transfer could not be added. Please try again.';
      error.hidden = false;
      button.textContent = 'Add to cart';
    } finally {
      form.dataset.submitting = 'false';
      button.disabled = false;
      // Re-evaluate upload and price; the app may clear or change either.
      form.dispatchEvent(new Event('change', {bubbles:true}));
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-size-ready]').forEach(root => root._sizeCleanup?.()));
})();
